import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import * as TriggerTimelineActions from 'Store/actions/triggerTimeline'
import * as UserProfilingActions from 'Store/actions/userProfiling'
import TutorialPopup from './TutorialPopup'

const mapDispatchToProps = (dispatch) => ({
  // Needed by TutorialPopup: doHideTtl, doRetrieveTtl
  ...bindActionCreators(TriggerTimelineActions, dispatch),
  // Needed by TutorialPopup: doUpdateTutorial
  ...bindActionCreators(UserProfilingActions, dispatch)
})

const mapStateToProps = (state) => ({
  dbSourceType: nullSafe(() => state.userProfiling.profiling.merchant.dbSourceTypes, []),
  clusterType: nullSafe(() => state.userProfiling.profiling.merchant.clusterType, ''),
  userRole: nullSafe(() => state.userProfiling.profiling.user.userRole, '')
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...ownProps,
    actions: dispatchProps
  })
)(TutorialPopup)
